import { defineAction, expression } from '~/prix'
import { dateOrIsoString } from '~/prix/types/date'
import { reportFormatSchema } from '~/utils/server/report'
import materialRequestReportAction from './materialRequestReport.action.json' with { type: 'json' }
import { z } from 'zod'
import { materialObject } from '../../material/materialObject'
import { materialRequestObject } from '../materialRequestObject'

const materialExpression = expression(materialRequestObject.shape)

const materialRequestReportDefinition = defineAction({
  ...materialRequestReportAction,

  input: z.object({
    format: reportFormatSchema,
    citizenId: materialRequestObject.shape.citizenId.nullish(),
    materialId: materialObject.shape.id.nullish(),
    startDate: dateOrIsoString().nullish(),
    endDate: dateOrIsoString().nullish(),
  }),
  output: z.any(),
})

export default materialRequestReportDefinition
